(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-story"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ps]').forEach(root=>{const track=root.querySelector('[data-ps-track]'),slides=[...track.children],dots=[...root.querySelectorAll('[data-ps-dots] button')];let i=0,t,sx=0,dx=0,drag=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;function paint(anim=true){if(!anim)track.style.transition='none';track.style.transform='translate3d('+(-i*100)+'%,0,0)';dots.forEach((d,n)=>d.classList.toggle('is-active',n===i));if(!anim)requestAnimationFrame(()=>track.style.transition='')}function go(n){i=(n+slides.length)%slides.length;paint()}function play(){clearInterval(t);if(!reduced)t=setInterval(()=>go(i+1),5000)}dots.forEach((d,n)=>d.addEventListener('click',()=>{go(n);play()}));root.addEventListener('pointerdown',e=>{drag=true;sx=e.clientX;dx=0;clearInterval(t);track.style.transition='none';track.setPointerCapture?.(e.pointerId)});root.addEventListener('pointermove',e=>{if(!drag)return;dx=e.clientX-sx;track.style.transform='translate3d('+((-i*100)+(dx/root.clientWidth*100))+'%,0,0)'});function end(){if(!drag)return;drag=false;track.style.transition='';if(Math.abs(dx)>40)i=(i+(dx<0?1:-1)+slides.length)%slides.length;paint();play()}root.addEventListener('pointerup',end);root.addEventListener('pointercancel',end);paint(false);play()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('product-media-gallery')){
  customElements.define('product-media-gallery',class extends HTMLElement{
    connectedCallback(){
      this.thumbs=[...this.querySelectorAll('[data-gallery-thumb]')];
      this.main=this.querySelector('.px-gallery__main-image');
      this.swipeArea=this.querySelector('[data-gallery-swipe]');
      this.index=0;
      this.startX=null;
      if(!this.main||!this.thumbs.length)return;

      this.main.addEventListener('dragstart',event=>event.preventDefault());
      this.thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>this.show(i)));

      if(this.swipeArea){
        this.swipeArea.addEventListener('pointerdown',event=>{
          this.startX=event.clientX;
        });

        this.swipeArea.addEventListener('pointerup',event=>{
          if(this.startX===null)return;
          const delta=event.clientX-this.startX;
          this.startX=null;
          if(Math.abs(delta)<45)return;
          if(delta<0){
            this.show((this.index+1)%this.thumbs.length);
          }else{
            this.show((this.index-1+this.thumbs.length)%this.thumbs.length);
          }
        });

        this.swipeArea.addEventListener('pointercancel',()=>{this.startX=null});
      }
    }

    show(i){
      const thumb=this.thumbs[i];
      if(!thumb)return;

      this.index=i;
      this.main.removeAttribute('srcset');
      this.main.removeAttribute('sizes');
      this.main.src=thumb.dataset.gallerySrc;
      this.main.alt=thumb.dataset.galleryAlt||'';

      this.thumbs.forEach((item,j)=>item.classList.toggle('is-active',j===i));
      thumb.scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'});
    }
  })
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-repair"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-svc]').forEach(root=>{const modal=root.querySelector('[data-svc-modal]'),form=root.querySelector('[data-svc-form]');root.querySelector('[data-svc-open]').addEventListener('click',()=>{modal.classList.add('is-open');modal.setAttribute('aria-hidden','false');document.body.style.overflow='hidden'});root.querySelectorAll('[data-svc-close]').forEach(x=>x.addEventListener('click',()=>{modal.classList.remove('is-open');modal.setAttribute('aria-hidden','true');document.body.style.overflow=''}));form.addEventListener('submit',e=>{e.preventDefault();const d=new FormData(form),v=k=>(d.get(k)||'').toString().trim();const msg=['*POWERNIX – Service & Repair Request*','','Name: '+v('name'),'Mobile: '+v('mobile'),'Order / Invoice No.: '+(v('order')||'Not provided'),'Machine Model: '+v('model'),'Serial No.: '+(v('serial')||'Not provided'),'Service Type: '+v('type'),'Problem: '+v('problem'),'Address / Pincode: '+v('address'),'','Please assist me with this service/repair request.'].join('\n');window.open('https://wa.me/917665535485?text='+encodeURIComponent(msg),'_blank','noopener')})});

  } catch(e) { console.error(e); }
})();
})();
